import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export const generateTroubleShootPDF = async (
	plantName: string,
	title: string,
	assetName: string,
	tags: any,
	dateRange: string,
	tab?: number
) => {
	const pdf = new jsPDF('portrait')

	const pageWidth =
		pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth()
	const pageHeight =
		pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight()

	pdf.setFont('times', 'bold')
	pdf.setFontSize(18)
	pdf.text(`${plantName}`, pageWidth / 2, 20, { align: 'center' })

	pdf.setFont('times', 'semibold')
	pdf.setFontSize(16)
	pdf.text(`${title}`, pageWidth / 2, 30, { align: 'center' })

	pdf.setFont('times', 'normal')
	pdf.setFontSize(12)
	pdf.text(`Date Range: ${dateRange.toString()}`, 10, 40, { align: 'left' })

	pdf.setFont('times', 'normal')
	pdf.setFontSize(12)
	pdf.text(`Assets: ${assetName.toString()}`, 10, 50, { align: 'left' })

	pdf.setFont('times', 'normal')
	pdf.setFontSize(12)
	pdf.text(`Graph:`, 10, 55, { align: "left" });

	const graphElement: any = document.getElementById(`simple-tabpanel-${tab || 1}`)
	const graphCanvas = await html2canvas(graphElement, {
		scale: 2, // for quality output
		logging: true // for debugging errors
	})
	const graphImgSrc = graphCanvas?.toDataURL('image/png')
	if (tab === 2) {
		const height = graphElement.offsetHeight
		pdf.addImage(graphImgSrc, 'PNG', 7, 65, 200, Math.min(height/7.5, 210))
	} else {
		pdf.addImage(graphImgSrc, 'PNG', 10, 70, 190, 100)
	}

	pdf.addPage('a4', 'p')
	pdf.setFont('times', 'normal')
	pdf.setFontSize(12)
	pdf.text(`Tags:`, 10, 13, { align: 'left' })
	tags = tags.join(', \n')

	const wrappedText = pdf.splitTextToSize(`${tags.toString()}`, 200)
	pdf.setFont('times', 'normal')
	pdf.setFontSize(10)
	let iterations = 1
	const margin = 15
	const defaultYJump = 5

	wrappedText.forEach((line: any) => {
		let posY = margin + defaultYJump * iterations++
		if (posY > pageHeight - margin) {
			pdf.addPage()
			iterations = 1
			posY = margin + defaultYJump * iterations++
		}
		pdf.text(line, 15, posY, { align: 'left' })
	})

	pdf.save(`${title} - ${plantName}.pdf`)
	return true
}
